module.exports = __webpack_public_path__ + "static/media/1.6d6cb53d.jpg";